import { httpPost } from '@/api/http';
import { V2_WARM_TRANSFER } from '@/constants/endpoint';

export const updateTransferCall = (transfereeNumber: string | undefined, transferTargetNumber: string | undefined) => {
  if (transfereeNumber && transferTargetNumber) {
    httpPost(V2_WARM_TRANSFER, null, {
      params: {
        transfereeNumber: transfereeNumber,
        transferTargetNumber: transferTargetNumber,
      },
    });
  }
};
